export const SET_USER_BALANCE_SUCCESS = "SET_USER_BALANCE_SUCCESS";
export const SET_USER_CURRENCY_SUCCESS = "SET_USER_CURRENCY_SUCCESS";
export const FETCH_EVENT_INFO_SUCCESS = "FETCH_EVENT_INFO_SUCCESS";
export const SET_USER_EXPOSURE_SUCCESS = "SET_USER_EXPOSURE_SUCCESS";
export const FETCH_PREMIUM_EVENT_INFO_SUCCESS =
  "FETCH_PREMIUM_EVENT_INFO_SUCCESS";
export const INPLAY_EVENTS_BY_PROVIDER_SUCCESS =
  "INPLAY_EVENTS_BY_PROVIDER_SUCCESS";
export const FETCH_EVENTS_BY_SPORT_TYPE_SUCCESS =
  "FETCH_EVENTS_BY_SPORT_TYPE_SUCCESS";
export const SET_SELECTED_EVENT_INFO = "SET_SELECTED_EVENT_INFO";
export const UPDATE_EVENT_ODDS_FROM_WS = "UPDATE_EVENT_ODDS_FROM_WS";
export const UPDATE_DREAM_EVENT_MARKETS_INFO =
  "UPDATE_DREAM_EVENT_MARKETS_INFO";
export const UPDATE_EVENTS_ODD = "UPDATE_EVENTS_ODD";
export const UPDATE_LIVE_EVENTS_ODD = "UPDATE_LIVE_EVENTS_ODD";
export const UPDATE_SECOUNDARY_MARKETS_INFO = "UPDATE_SECOUNDARY_MARKETS_INFO";
export const UPDATE_EVENT_MARKETS_INFO = "UPDATE_EVENT_MARKETS_INFO";
export const UPDATE_FANCY_MARKETS_INFO = "UPDATE_FANCY_MARKETS_INFO";
export const UPDATE_PREMIUM_ODDS_FROM_WS = "UPDATE_PREMIUM_ODDS_FROM_WS";
export const UPDATE_TOPIC_URLS = 'UPDATE_TOPIC_URLS';
export const SET_IS_CONNECTED = 'SET_IS_CONNECTED';
